import { render } from "./popTable.vue?vue&type=template&id=a19b26f2&scoped=true"
import script from "./popTable.vue?vue&type=script&lang=js"
export * from "./popTable.vue?vue&type=script&lang=js"

import "./popTable.vue?vue&type=style&index=0&id=a19b26f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19b26f2"]])

export default __exports__